module.exports = __WEBPACK_EXTERNAL_MODULE_53__;


/*****************
 ** WEBPACK FOOTER
 ** external {"amd":"sinon-chai","commonjs":"sinon-chai","commonjs2":"sinon-chai","root":"sinonChai"}
 ** module id = 53
 ** module chunks = 1 2
 **/